import { render, staticRenderFns } from "./PurchasedCouponsForm.vue?vue&type=template&id=6d144c66"
import script from "./PurchasedCouponsForm.vue?vue&type=script&lang=js"
export * from "./PurchasedCouponsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports